export default __webpack_public_path__ + "static/media/the_sun.89ce35b2.png";